module.exports = __webpack_public_path__ + "static/media/bathroom-tap-clean.4ce2bfcd.png";